// import { readJson } from '../../services/fileOps'
// import Marker from './marker'
import Schema from './schema'
import {BasicManagedFile} from './basicManagedFile'
import { LANG } from '../Data/typeDirs'
// import { MASK_FLAG } from '../ControlManager/scripts/utils'
// import { upgradeOldLang } from '../ControlManager/scripts/legacy'

class LanguageFile extends BasicManagedFile {

  constructor(args){
    super(args)
    this.ext = LanguageFile.getExt()
    this.typeDir = LanguageFile.getTypeDir()
    this.type = LanguageFile.getTypeDir()
    this._fulcId = null
  }

  static getIndices(){
    return `${BasicManagedFile.getIndices()},_fulcId`
  }

  getLanguage(){
    return Schema.tryGetAttr(LANG, x=>this.content.content[0].tree.binding.content[0]._name)
  }

  static getExt(){
    return 'slf.json'
  }

  static getTypeDir(){
    return LANG
  }

}

export default LanguageFile
